module.exports = __webpack_public_path__ + "media/images/philips_logo-e606ce002086db4da169a8d808664238.png";